import { withInstall } from "@/shared/lib"
import Icon from "./ui/icon.vue"

export const CIcon = withInstall(Icon)

export type IconInstance = InstanceType<typeof CIcon>

export * from './model/types'
